import PropTypes from 'prop-types';
import React from 'react';

const LabelAsHTML = props => {
	const { label, isStyleEditable, vehicleTypeClass, typeClass } = props;

	return (
		/* eslint react/no-danger: 0 */
		<span
			className="price-label"
			data-style-editor-id={
				isStyleEditable ? `vdp-${typeClass}-price-label` : null
			}
			data-style-editor-text={
				isStyleEditable
					? `.vdp .${vehicleTypeClass}.pricing-detail .${typeClass} .price-label`
					: null
			}
			dangerouslySetInnerHTML={{ __html: label }}
		/>
	);
};

LabelAsHTML.defaultProps = {
	isStyleEditable: false,
	vehicleTypeClass: '',
	typeClass: ''
};

LabelAsHTML.propTypes = {
	label: PropTypes.string.isRequired,
	isStyleEditable: PropTypes.bool,
	vehicleTypeClass: PropTypes.string,
	typeClass: PropTypes.string
};

export default LabelAsHTML;



// WEBPACK FOOTER //
// ./src/components/LabelAsHTML.jsx